export default {"src":"/_next/static/media/ic_lock.9b264199.svg","height":10,"width":8,"blurWidth":0,"blurHeight":0};